import React from 'react';
import { Grid, Typography } from '@mui/material';
import { Form, FormikProvider, FormikProps } from 'formik';
import { CheckInput, TextInput } from '@lp/lp-ui';
import { useCurrentUser } from '../../app/useCurrentUser';

export interface InviteeModel {
    email: string,
    twoFactorEnabled: boolean
}

interface InviteeEmailPanelProps {
    formik: FormikProps<InviteeModel>
}

// No Enabled toggle on purpose: the server rejects a disabled invitee, so offering it would only
// ever produce a 400.
const InviteeEmailPanel: React.FC<InviteeEmailPanelProps> = ({ formik }) => {
    const [isAdmin] = useCurrentUser();
    const { errors, touched, getFieldProps } = formik;

    return (
        <FormikProvider value={formik}>
            <Form autoComplete="off" noValidate>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <Typography variant="body2" color="text.secondary">
                            The invitee receives an email with a link to set a password and complete their profile.
                        </Typography>
                    </Grid>
                    <Grid item xs={8}>
                        <TextInput
                            isEditing={isAdmin}
                            type="string"
                            label="Email"
                            required
                            {...getFieldProps("email")}
                            error={Boolean(touched.email && errors.email)}
                            helperText={touched.email && errors.email} />
                    </Grid>
                    <Grid item xs={12}>
                        <CheckInput
                            label="MFA"
                            isEditing={isAdmin}
                            {...getFieldProps("twoFactorEnabled")}
                            error={false}
                            helperText="" />
                    </Grid>
                </Grid>
            </Form>
        </FormikProvider>
    );
};

export default InviteeEmailPanel;
